/* eslint-disable multiline-ternary */
import React from 'react'
import { Box, Typography, Skeleton } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import useAccountInfo from '../../../../hooks/useAccountInfo'

const useStyles = makeStyles(({ spacing, palette, typography }) => ({
  root: {
    border: `1px solid ${palette.grey.shade[20]}`,
    padding: spacing(3)
  },
  title: {
    ...typography.body.m,
    fontWeight: typography.fontWeightMedium,
    color: palette.grey.shade[90],
    marginBottom: spacing(2)
  },
  subtitle: {
    ...typography.body.m,
    fontWeight: typography.fontWeightMedium,
    color: palette.grey.shade[90]
  },
  plan: {
    borderLeft: `4px solid ${palette.primary.main}`,
    paddingLeft: spacing(2.5)
  }
}))

const Plan = ({
  title = 'Your current plan details',
  insideContainer = true,
  panel
}) => {
  const classes = useStyles()
  const { accountInfo, accountInfoLoaded } = useAccountInfo()

  const renderContent = () => {
    return (
      <>
        <Typography className={classes.title}>{title}</Typography>
        <Box className={classes.plan}>
          <Typography
            data-test='retention-plan-membership'
            className={classes.subtitle}
          >
            {accountInfoLoaded ? (
              `${accountInfo.plan.name} Membership`
            ) : (
              <Skeleton width='50%' />
            )}
          </Typography>
          {panel}
        </Box>
      </>
    )
  }

  return insideContainer ? (
    <Box className={classes.root}>{renderContent()}</Box>
  ) : (
    renderContent()
  )
}

export default Plan
